import type { RangePickerProps } from 'antd/es/date-picker';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import type { DateRangeValue } from '@/types/antd';

dayjs.extend(customParseFormat);

export type PickProps = Partial<{
    className: string;
    disabled: boolean;
    format: string;
    placeholder: string;
    value: string | Dayjs | null;
    onChange: (dateString: string | null, date: Dayjs | null) => void;
}>;

export type PickRangeProps = Partial<{
    placeholder: [string, string];
    className: string;
    disabled: boolean;
    format: string;
    value: Interval<Dayjs> | Interval<string> | null;
    onChange: (date: Interval<Dayjs> | null) => void;
}>;

const hoje = dayjs();

export const rangePickerPresets: NonNullable<RangePickerProps['presets']> = [
    { label: 'Hoje', value: [hoje, hoje] },
    { label: 'Esta semana', value: [hoje.startOf('week'), hoje.endOf('week')] },
    { label: 'Este mês', value: [hoje.startOf('month'), hoje.endOf('month')] },
    { label: 'Últimos 30 dias', value: [hoje.subtract(30, 'days'), hoje] },
    { label: 'Últimos 60 dias', value: [hoje.subtract(60, 'days'), hoje] },
    { label: 'Últimos 90 dias', value: [hoje.subtract(90, 'days'), hoje] },
    { label: 'Próximos 90 dias', value: [hoje, hoje.add(90, 'days')] },
];

export function getValue(value: string | Dayjs | null | undefined, format: string): Dayjs | null {
    return value ? (typeof value === 'string' ? dayjs(value, format) : value) : null;
}

export function getRangeValue(
    value: Interval<string> | Interval<Dayjs> | null | undefined,
    format: string,
): DateRangeValue | null {
    if (!value) {
        return null;
    }

    if (typeof value.start === 'string' && typeof value.end === 'string') {
        const de = dayjs(value.start, format);
        const ate = dayjs(value.end, format);

        if (!de.isValid() || !ate.isValid()) {
            return null;
        }

        return [dayjs(value.start, format), dayjs(value.end, format)] as DateRangeValue;
    }

    return [value.start, value.end] as DateRangeValue;
}
